import React, { useEffect } from 'react';

import { Switch } from 'react-router-dom';

import LayoutRoute from 'common/components/LayoutRoute';
import {
    BlankLayout,
    DefaultLayout,
    LoginLayout,
    PageNotFoundLayout,
} from 'common/layouts';
import { initSessionActions } from 'common/utils/helpers/session';

import bomExpress from '../bomExpress';
import companyGeneral from '../companyGeneral';
import companyUsers from '../companyUsers';
import contactFile from '../contactFile';
import contacts from '../contacts';
import createAccount from '../createAccount';
import forgotPassword from '../forgotPassword';
import login from '../login';
import multiPanelLayout from '../multiPanelLayout';
import multiTemplateReview from '../multiTemplateReview';
import panels from '../panels';
import profile from '../profile';
import project from '../project';
import projects from '../projects';
import rackingList from '../rackingList';
import rackingProposals from '../rackingProposals';
import resetPassword from '../resetPassword';
import systems from '../systems';
import templateRender from '../templateRender';

const Container = () => {
    useEffect(() => {
        initSessionActions();
    }, []);

    return (
        <Switch>
            <LayoutRoute
                component={login.Container}
                isPublic
                layout={LoginLayout}
                path="/login"
            />

            <LayoutRoute
                component={createAccount.Container}
                isPublic
                layout={LoginLayout}
                path="/create-account"
            />

            <LayoutRoute
                component={forgotPassword.Container}
                exact
                isPublic
                layout={LoginLayout}
                path="/reset-password"
            />

            <LayoutRoute
                component={resetPassword.Container}
                exact
                isPublic
                layout={LoginLayout}
                path="/reset-password/:uuid/:token"
            />

            <LayoutRoute
                component={contacts.Container}
                exact
                layout={DefaultLayout}
                path="/contacts"
            />

            <LayoutRoute
                component={contactFile.Container}
                exact
                layout={DefaultLayout}
                path="/contacts/:contactId"
            />

            <LayoutRoute
                component={project.Container}
                exact
                layout={DefaultLayout}
                path="/contacts/:contactId/:projectId"
            />

            <LayoutRoute
                component={projects.Container}
                exact
                layout={DefaultLayout}
                path={['/', '/projects']}
            />

            <LayoutRoute
                component={rackingList.Container}
                exact
                layout={DefaultLayout}
                path={['/products/racking']}
            />

            <LayoutRoute
                component={panels.Container}
                exact
                layout={DefaultLayout}
                path={['/products/panels']}
            />

            <LayoutRoute
                component={systems.Container}
                exact
                layout={DefaultLayout}
                path={['/products/system-presets']}
            />

            <LayoutRoute
                component={companyGeneral.Container}
                exact
                layout={DefaultLayout}
                path="/company/general"
            />
            <LayoutRoute
                component={companyUsers.Container}
                exact
                layout={DefaultLayout}
                path="/company/users"
            />

            <LayoutRoute
                component={multiPanelLayout.Container}
                exact
                layout={DefaultLayout}
                path="/panel-layout/:uid"
            />

            <LayoutRoute
                component={multiTemplateReview.Container}
                exact
                layout={DefaultLayout}
                path="/panel-layout/preview/:uid"
            />

            <LayoutRoute
                component={bomExpress.Container}
                exact
                layout={DefaultLayout}
                path="/bom-express/:uid"
            />

            <LayoutRoute
                component={profile.Container}
                exact
                layout={DefaultLayout}
                path={['/profile', '/profile/:section']}
            />

            <LayoutRoute
                component={templateRender.Container}
                isPublic
                layout={BlankLayout}
                path="/template-render/:uid"
            />

            <LayoutRoute
                component={rackingProposals.Container}
                exact
                layout={DefaultLayout}
                path="/racking-proposals"
            />

            <LayoutRoute layout={PageNotFoundLayout} path="*" />
        </Switch>
    );
};

export default Container;
